function _getGifElement(gifName, role) {
  return `<p class="m-b-10 m-t-10">
            <a href="` + _getGifPath(false, role, gifName) + `" target="_blank">
              <img border="0" alt="Save animated gif" src="` + _getGifPath(true, role, gifName) + `" width="100%" height="100%">
            </a>
          </p>`;
}

function _getGifPath(isPreview, role, gifName) {
  let basePath = '//cdn.ringba.com/tour/calllog/';
  role = role === 'user' ? 'admin' : role;
  
  if (isPreview) {
    basePath += 'preview/';
  }
  
  return [basePath, role, '/', gifName, '.gif'].join('');
}

export default function getCallLogsTourSteps(role) {
  let startStepsFrom = 1;

  let steps = [
    {
      target: 'div.reporting-call-logs-data',
      header: {
        title: '🙋‍♀️ Welcome to the New Call Logs!',
      },
      content: 'We improved the way you can see your call details, providing a more customized reporting experience so you can get the data that you need and make data-driven decisions faster.',
      params: {
        placement: 'top',
        enableScrolling: false
      },
      highlight: true
    },
    {
      roles: ['admin'],
      target: 'div.reporting-call-logs-data',
      header: {
        title: '📝 What’s new?',
      },
      content: `Let's start showing you the new tools that you will see in this tour:
          <br></br>
          <ol class="p-l-15">
            <li>Bulk calls actions</li>
            <li>Customized columns</li>
            <li>Multi-column sorting</li>
            <li>Timeline view</li>
            <li>Filters</li>
            <li>New layout for events, records and tags</li>
            <li>Saving reports</li>
          </ol>
          <p>Let’s see how they work!</p>`,      
      params: {
        placement: 'bottom',
        enableScrolling: false
      },
      highlight: true
    },
    {
      roles: ['user'],
      target: 'div.reporting-call-logs-data',
      header: {
        title: '📝 What’s new?',
      },
      content: `Let's start showing you the new tools that you will see in this tour:
          <br></br>
          <ol class="p-l-15">
            <li>Customized columns</li>
            <li>Multi-column sorting</li>
            <li>Timeline view</li>
            <li>Filters</li>
            <li>New layout for events, records and tags</li>
            <li>Saving reports</li>
          </ol>
          <p>Let’s see how they work!</p>`,      
      params: {
        placement: 'bottom',
        enableScrolling: false
      },
      highlight: true
    },
    {
      roles: ['buyer', 'publisher'],
      target: 'div.reporting-call-logs-data',
      header: {
        title: '📝 What’s new?',
      },
      content: `Let's start showing you the new tools that you will see in this tour:
          <br></br>
          <ol class="p-l-15">
            <li>Customized columns</li>
            <li>Multi-column sorting</li>
            <li>Timeline view</li>
            <li>Filters</li>
            <li>New layout for events and records</li>
            <li>Saving reports</li>
          </ol>
          <p>Let’s see how they work!</p>`,      
      params: {
        placement: 'bottom',
        enableScrolling: false
      },
      highlight: true
    },
    {
      roles: ['admin'],
      target: '.bulk-actions-dropdown.dropdown > button.btn-primary',
      header: {
        title: '📌 Bulk Call Actions',
      },
      content: `You can select up to 10 rows for adding tag annotations or blocking caller IDs. If you select the wrong row, you can undo the selection by clicking again in the row, or you can click on the "Clear selection" button.`
               + _getGifElement('bulkcallsaction', role),
      params: {
        placement: 'auto-start'
      },
      highlight: true
    },    
    {
      roles: ['admin', 'publisher', 'user'],
      target: '.ag-side-bar.ag-unselectable.ag-side-bar-right .ag-tool-panel-wrapper',
      header: {
        title: '🧾 Customize Reporting Columns',
      },
      content: `To customize the columns in your report, click on "Customize columns" and select the columns that you would like to show in your report. Now <b>tags</b> can be displayed as columns to add more insight to your reports.`
               + _getGifElement('customizecolumn', role),
      params: {
        placement: 'right'
      },
      highlight: true,
      expandsCustomizeColumn: true,
    },
    {
      roles: ['buyer'],
      target: '.ag-side-bar.ag-unselectable.ag-side-bar-right .ag-tool-panel-wrapper',
      header: {
        title: '🧾 Customize Reporting Columns',
      },
      content: `To customize the columns in your report, click on "Customize columns" and select the columns that you would like to show in your report.`
               + _getGifElement('customizecolumn', role),
      params: {
        placement: 'right'
      },
      highlight: true,
      expandsCustomizeColumn: true,
    },
    {
      target: '#main-content > div.master_container > div > div > call-log-vue-container > div > div.reporting-call-logs-data > div.m-t-15 > div.ag-grid-call-logs__container > div > div > div.ag-root-wrapper-body.ag-layout-normal > div.ag-root.ag-unselectable.ag-layout-normal > div.ag-header.ag-pivot-off',
      header: {
        title: '⬇️ Multi-Column Sorting & Column Reordering',
      },
      content: `It's also possible to multi sort the columns if you hold <code>SHIFT</code> and click on multiple columns to sort on them at the same time. The sorting priority will be displayed beside the column name. Drag column headers to reorder them to best suit your needs.`
               + _getGifElement('multisort', role),
      params: {
        placement: 'auto-start'
      },
      highlight: true
    },    
    {
      target: 'call-log-vue-container > div > div.reporting-call-logs-data > div:nth-child(2) > div',
      header: {
        title: '📊 Timeline View',
      },
      content: `With this new timeline view it is easier to zoom in and out to isolate calls from a specific time range. Just drag on the chart to select a new time range.`
               + _getGifElement('timeline', role),
      params: {
        placement: 'bottom'
      },
      highlight: true,
      scrollsToTop: true
    },        
    {
      target: 'div.reporting-settings-container.m-b-10 > div:nth-child(2)',
      header: {
        title: '🔍 Filters',
      },
      content: `The filters will be displayed at the top of the page and you can combine multiple filters by using "AND"/"OR" logic to filter it in different levels. It's also possible to copy and filter using this option in your call details.`
               + _getGifElement('filters', role),
      params: {
        placement: 'top'
      },
      highlight: true
    },        
    {
      roles: ['admin', 'publisher', 'user'],
      target: 'div.ag-root-wrapper-body.ag-layout-normal div.ag-body-viewport.ag-layout-normal.ag-row-no-animation',
      header: {
        title: '🏷️ Optimized layout for Events, Records, and Tags',
      },
      content: `Call Details contain the same data as our previous reporting interface but with a streamlined layout for Events, Records, and Tags to provide you with a better user experience.`
               + _getGifElement('newlayouteventstagrecord', role),
      params: {
        placement: 'left',
        enableScrolling: true
      },
      highlight: true,
      expandsCallDetail: true
    },      
    {
      roles: ['buyer'],
      target: 'div.ag-root-wrapper-body.ag-layout-normal div.ag-body-viewport.ag-layout-normal.ag-row-no-animation',
      header: {
        title: '🏷️ Optimized layout for Events and Records',
      },
      content: `Call Details contain the same data as our previous reporting interface but with a streamlined layout for Events and Records to provide you with a better user experience.`
               + _getGifElement('newlayouteventstagrecord', role),
      params: {
        placement: 'left',
        enableScrolling: true
      },
      highlight: true,
      expandsCallDetail: true
    },      
    {
      roles: ['admin', 'user'],
      target: '.saved-report-form',
      header: {
        title: '💾 Saving Reports',
      },
      content: `Call Logs visibility can be set to Personal or Shared. The ‘Personal’ view can only be viewed by the user who created it. Alternatively, the ‘Shared’ view will allow other account admins to see the report.`
               + _getGifElement('save', role),
      params: {
        placement: 'auto-start',
        enableScrolling: false
      },
      highlight: true,
      scrollsToTop: true
    },     
    {
      roles: ['buyer', 'publisher'],
      target: '.saved-report-form',
      header: {
        title: '💾 Saving Reports',
      },
      content: `Call Logs visibility can be set to Personal. The ‘Personal’ view can only be viewed by the user who created it.`
               + _getGifElement('save', role),
      params: {
        placement: 'auto-start',
        enableScrolling: false
      },
      highlight: true,
      scrollsToTop: true
    },   
    {
      target: 'div.reporting-call-logs-data',
      header: {
        title: '🏁 Get Started',
      },
      content: `Thank you for joining us on this tour of our new Call Logs reporting interface! If you have any questions, please contact our chat support team to get personalized support from Ringba engineers by clicking the chat icon on the header 💬.`,
      params: {
        placement: 'bottom',
        enableScrolling: false
      }
    }
  ];

  steps = steps.filter(function (s) {
    if (!s.roles) {
      return true;
    }

    return s.roles.includes(role);
  });

  let totalSteps = steps.length - startStepsFrom - 1;

  return steps.map((step, index) => {
    let content = step.content;
    if (index > startStepsFrom) {
      content += `<p class="text-center m-t-5 f-s-11">Step ${index - startStepsFrom}/${totalSteps}</p`;
    }

    return {
      ...step,
      content
    };
  });
  
}